const API_BASE_URL = "https://5olj3l3dvf.execute-api.us-east-1.amazonaws.com/prod";
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

// Push is available when the browser supports it AND a VAPID key is configured.
export const isPushSupported = () =>
  Boolean(
    VAPID_PUBLIC_KEY &&
      "serviceWorker" in navigator &&
      "PushManager" in window &&
      "Notification" in window
  );

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
};

const registerServiceWorker = async () => {
  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  return navigator.serviceWorker.register(swUrl);
};

// Returns "subscribed" | "unsubscribed" | "denied" | "unsupported"
export const getPushStatus = async () => {
  if (!isPushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  try {
    const registration = await navigator.serviceWorker.getRegistration(
      `${process.env.PUBLIC_URL}/service-worker.js`
    );
    const subscription = await registration?.pushManager.getSubscription();
    return subscription ? "subscribed" : "unsubscribed";
  } catch {
    return "unsubscribed";
  }
};

export const subscribeToPush = async () => {
  const registration = await registerServiceWorker();
  await navigator.serviceWorker.ready;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error(permission === "denied" ? "denied" : "dismissed");
  }

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
  });

  const response = await fetch(`${API_BASE_URL}/push/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ subscription: subscription.toJSON() }),
  });
  if (!response.ok) {
    await subscription.unsubscribe().catch(() => {});
    throw new Error("Failed to save subscription");
  }
  return subscription;
};

export const unsubscribeFromPush = async () => {
  const registration = await navigator.serviceWorker.getRegistration(
    `${process.env.PUBLIC_URL}/service-worker.js`
  );
  const subscription = await registration?.pushManager.getSubscription();
  if (!subscription) return;

  const endpoint = subscription.endpoint;
  await subscription.unsubscribe();
  await fetch(`${API_BASE_URL}/push/unsubscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ endpoint }),
  }).catch(() => {});
};
